import { format, isValid, parse } from 'date-fns';

export const formatAxisDate = (v: string) => {
  const d = parse(v, 'yyyy-MM-dd', new Date());
  return isValid(d) ? format(d, 'MMM d') : v;
};
